module.exports = __webpack_public_path__ + "static/a11y-33419175e9e0d890c14bd56a7f808743.png";